import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { BadgeNew } from 'ziphy-web-shared/basic/lib/simple';
import PlaceholderHelpers from '@nedoShared/modules/notes/placeholder/Placeholder.helpers';
import styles from './PlaceholderText.module.scss';
const { getBadgeColor } = PlaceholderHelpers;
const PlaceholderText = ({ elementId, data, isBlocked, isLoading, isPlain, isInvalid }) => {
    const isEditable = !isBlocked && !data.blocked && !isPlain;
    return (_jsx(BadgeNew, { id: elementId, valueId: `ref_${data.id}`, value: data.value, placeholder: data.title, editable: isEditable, color: getBadgeColor(data), className: classNames(styles.badge, {
            [styles.badgeGray]: isBlocked,
            [styles.badgePurple]: data.blocked && data.source === 'system',
        }), showTextSelection: false, "data-placeholder": true, "data-placeholder-id": data.id, contentEditable: isEditable, isLoading: isLoading, loadingPosition: 'start', isPlain: isPlain, isInvalid: isInvalid }));
};
export default observer(PlaceholderText);
